import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.my',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-9101">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-9102">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-9103">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-9104" />
          <span data-id="element-9105">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-9106">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-9107">
          <div className="flex justify-between items-center" data-id="element-9108">
            <h2 className="text-xl font-bold" data-id="element-9109">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-9110">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-9111">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-9112">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-9113">
          <div className="p-6 border-r border-gray-200" data-id="element-9114">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9115">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9116">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9117">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-9118">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9119">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9120">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9121">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9122">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9123">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9124">
            <div data-id="element-9125">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9126">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9127">{reservation.booking.id}</p>
            </div>
            <div data-id="element-9128">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9129">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9130">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9131">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9132">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9133">
            <div data-id="element-9134">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9135">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9136">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-9137">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9138">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9139">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9140">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9141">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9142">
            <div data-id="element-9143">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9144">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9145">{reservation.room.name}</p>
            </div>
            <div data-id="element-9146">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9147">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9148">{reservation.room.view}</p>
            </div>
            <div data-id="element-9149">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9150">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9151">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9152">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9153">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-9154">
            <h4 className="text-base font-medium mb-4" data-id="element-9155">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9156">
              <div data-id="element-9157">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9158">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9159">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-9160">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9161">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9162">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-9163">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9164">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9165">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-9166">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9167">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9168">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-9169">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9170">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9171">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-9172">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9173">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9174">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-9175">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9176">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-9177">
            <div data-id="element-9178">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9179">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9180">{reservation.rate.name}</p>
            </div>
            <div data-id="element-9181">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9182">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9183">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-9184">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9185">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-9186">
            <div className="flex justify-between" data-id="element-9187">
              <p className="text-sm text-gray-500" data-id="element-9188">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9189">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-9190">
              <p className="text-sm text-gray-500" data-id="element-9191">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9192">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-9193">
              <p className="text-sm font-medium" data-id="element-9194">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-9195">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}